(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MyAccountHelpers = /*#__PURE__*/function () {
  function MyAccountHelpers() {
    _classCallCheck(this, MyAccountHelpers);
  }

  _createClass(MyAccountHelpers, null, [{
    key: "clearSubmitResponse",
    value: function clearSubmitResponse() {
      jQuery(".submit-response").removeClass("active fasts-alert--success fasts-alert--error fasts-alert--top").find(".submit-response--message").html("");
    }
  }, {
    key: "showSubmitError",
    value: function showSubmitError(msg) {
      jQuery(".submit-response").addClass("fasts-alert--error  fasts-alert--top active").find(".submit-response--message").append(msg);
    }
  }, {
    key: "showSubmitSuccess",
    value: function showSubmitSuccess(msg) {
      jQuery(".submit-response").addClass("fasts-alert--success fasts-alert--top active").find(".submit-response--message").append(msg);
    }
  }]);

  return MyAccountHelpers;
}();

exports["default"] = MyAccountHelpers;

},{}],2:[function(require,module,exports){
"use strict";

var _MyAccountHelpers = _interopRequireDefault(require("./modules/MyAccountHelpers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function ($) {
  $(document).ready(function () {
    var signup_button = $(".attendee-ajax-button");
    signup_button.click(function () {
      submitSignups();
    });

    var submitSignups = function submitSignups() {
      _MyAccountHelpers["default"].clearSubmitResponse();

      signup_button.addClass("btn--loading");
      var data = {};
      $.map($(".fasts-attendee-form input"), function (element) {
        data[element.name] = element.value;
      });
      $.ajax({
        type: "post",
        url: ajax_data.url,
        data: _objectSpread({
          action: "save_attendee_edit"
        }, data),
        dataType: "json",
        success: function success(res) {
          signup_button.removeClass("btn--loading"); // Error

          if (!res.success) {
            _MyAccountHelpers["default"].showSubmitError(res.data);

            return;
          } // Show success message


          _MyAccountHelpers["default"].showSubmitSuccess(res.data.message);
        },
        error: function error(xhr, textStatus, errorThrown) {
          _MyAccountHelpers["default"].showSubmitError(errorThrown);

          signup_button.removeClass("btn--loading");
        }
      });
    };
  });
})(jQuery);

},{"./modules/MyAccountHelpers":1}]},{},[2]);
